export default "__VITE_ASSET__DxrIB8rW__"